const setTransitionShownInLocalStorage = () => {
  localStorage.setItem(
    "userSeenRecommendationsTransition",
    String(Date.now())
  );
};

const userSawTransitionRecently = () => {
  const seenAt = parseInt(
    localStorage.getItem("userSeenRecommendationsTransition") ?? "",
    10
  );

  if (Number.isNaN(seenAt)) {
    return false;
  }
  const RECENCY_MS = 60 * 60 * 1000;
  return Date.now() - seenAt < RECENCY_MS;
};

const transitionElement = document.querySelector(
  ".js-recommendations-transition",
);

const showTransitionToUser = () => {
  if (transitionElement) {
    transitionElement.classList.add("show-recommendations-transition");
  }
};

if (userSawTransitionRecently()) {
  // if we don't remove the element then it will still show on the page, just without the transition
  transitionElement.remove();
} else {
  showTransitionToUser();
  setTransitionShownInLocalStorage();
}
